module.exports = {
    /**
     * @description 应用id
     */
     sapp_id: 'test123',
    /**
     * @description 应用id
     */
     sapp_name: '六处六优',

    //  baseUrl: 'https://apilcly.eazyun.com',
    // baseUrl: 'http://192.168.2.46:9996',
    baseUrl: process.env.VUE_APP_BASE_API.replace(/\"/g,"")
  }
  


// WEBPACK FOOTER //
// ./src/settings.js